import gql from 'graphql-tag';

export const deleteStudentMutation = gql`
  mutation DeleteStudent($studentId: String!) {
    deleteStudent(studentId: $studentId)
  }
`;
